<div class="hero" [style.background-image]="'url(' + image() + ')'">
    @if (title().length > 0) {
        <div class="content">
            <h1 class="italic">{{ title() }}</h1>
            <img class="rounded-lg-3" [src]="separator()" alt="separator" width="150">
            <p><ng-content /></p>
        </div>
    }
</div>